import React from 'react';

import Step from './components/Step';
import StepPanel from './components/StepPanel';
import Stepper from './components/Stepper';
import { MultiStepProvider } from './context';

interface MultiStepProps {
  activeStepId: string;
  setStep: (step: string) => void;
}

const MultiStep: React.FC<React.PropsWithChildren<MultiStepProps>> = ({
  children,
  activeStepId,
  setStep,
}) => {
  return (
    <MultiStepProvider activeStepId={activeStepId} setStep={setStep}>
      {children}
    </MultiStepProvider>
  );
};

export { MultiStep, Step, StepPanel, Stepper };
